export default class PublishedOrganiser {
    id: number;
    dofid: number;
    schoolID: number;
    archiveGroupID: number;
    groupName: string;
    startDate: Date;
    endDate: Date;
    name: string;
    useMonday: boolean;
    useTuesday: boolean;
    useWednesday: boolean;
    useThursday: boolean;
    useFriday: boolean;
    useSaturday: boolean;
    useSunday: boolean;
    isMarkPublished: boolean;
    displayName: string;
    folderID: number;
    status: string;
    version: string;
    statusMessage: string;
    createdOn: Date;
    createdBy: number;
    editedOn: Date;
    editedBy: number;

    get publishedOn(): Date {
        return this.editedOn ?? this.createdOn;
    }

    get useDays() {
        var res = "";
        if (this.useMonday) res += "Monday, ";
        if (this.useTuesday) res += "Tuesday, ";
        if (this.useWednesday) res += "Wednesday, ";
        if (this.useThursday) res += "Thursday, ";
        if (this.useFriday) res += "Friday, ";
        if (this.useSaturday) res += "Saturday, ";
        if (this.useSunday) res += "Sunday, ";

        if (res.length > 0) res = res.substring(0, res.length - 2);
        else res = "No days";

        return res;
    }

    constructor(data: Partial<PublishedOrganiser>) {
        Object.assign(this, data);

        this.startDate = this.startDate ? this.startDate.toDate() : null;
        this.endDate = this.endDate ? this.endDate.toDate() : null;
        this.createdOn = this.createdOn ? this.createdOn.toDate() : null;
        this.editedOn = this.editedOn ? this.editedOn.toDate() : null;
    }
}
